const selector = '.menu-list__link[href="#OkBrandMenu"]';

function getTrigger(event) {
  return event.target instanceof Element ? event.target.closest(selector) : null;
}

document.addEventListener(
  'click',
  (event) => {
    const trigger = getTrigger(event);
    if (!(trigger instanceof HTMLElement)) return;

    const headerMenu = trigger.closest('header-menu');
    if (headerMenu && typeof headerMenu.toggleCustomMenu === 'function') {
      headerMenu.toggleCustomMenu(event, trigger);
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    trigger.setAttribute('aria-expanded', String(trigger.getAttribute('aria-expanded') !== 'true'));
  },
  true
);

document.addEventListener(
  'keydown',
  (event) => {
    if (event.key !== 'Escape') return;

    const trigger = getTrigger(event);
    if (!(trigger instanceof HTMLElement)) return;

    const headerMenu = trigger.closest('header-menu');
    if (headerMenu && typeof headerMenu.closeCustomMenu === 'function') {
      event.preventDefault();
      headerMenu.closeCustomMenu(trigger);
      return;
    }

    trigger.setAttribute('aria-expanded', 'false');
    trigger.focus({ preventScroll: true });
  },
  true
);
